import { Row, Col, Spin, Typography } from 'antd'
import CustomInput from '../../../components/CustomInput/Input'
import CustomSelect from "../../../components/CustomSelect/CustomSelect";
import { capitalizeWords, websiteRules, financialSummaryRules, descriptionRules } from '../../../helpers/helpers'
import { useSelector } from "react-redux";
import { ERROR_MSGS, TITLE_TXT, YESORNO } from "../../../constants/constants";
import CustomDatePicker from "../../../components/CustomDatePicker/CustomDatePicker";
import dayjs from 'dayjs';
import { isInvoiceStyleCategory } from "../../../helpers/dealCategoryProducts";

const { Text } = Typography

const KycAdditionalInfo = ({ isReview, isNarrativeReview }) => {
    const lockNarrative = isNarrativeReview ?? isReview;
    const { dropdownData, loading } = useSelector((state) => state.enqMngt);

    return (
        <Spin spinning={loading}>
            <Text className='kyc-subtitle'>{TITLE_TXT.ADDITIONAL_INFO}</Text>
            <Row gutter={[24, 0]}>
                <Col xs={24} md={12}>
                    <CustomDatePicker
                        label="Incorporation Date"
                        name="incorporationDate"
                        isRequired={true}
                        disabled={isReview}
                        placeholder="Select Incorporation Date"
                        rules={[{ required: true, message: ERROR_MSGS.ENTER_INC_DATE }]}
                        disabledDate={(current) => current && current >= dayjs().startOf("day")}
                    />
                </Col>
                <Col xs={24} md={12}>
                    <CustomSelect
                        name="hasMultipleGstin"
                        label="Do you have multiple GSTIN?"
                        placeholder="Select Yes/No"
                        isRequired={true}
                        disabled={isReview}
                        options={YESORNO?.map((item) => ({
                            value: item.value,
                            label: item.label,
                        }))}
                    />
                </Col>

                <Col xs={24} md={12}>
                    <CustomInput
                        label="Business Website"
                        name="busWebsite"
                        type="text"
                        removeHttps={true}
                        disabled={isReview}
                        isRequired={false}
                        placeholder="Enter Business Website"
                        rules={websiteRules}
                    />
                </Col>
                <Col xs={24} md={12}>
                    <CustomSelect
                        label="Deal Type"
                        name="dealType"
                        showSearch
                        // disabled={isReview}
                        isRequired={true}
                        disabled
                        placeholder="Select Deal Type"
                        options={dropdownData?.category?.map((type) => ({
                            value: type.dealCategoryId,
                            label: capitalizeWords(type.dealCategoryName),
                            // disabled: type.dealCategoryId !== "DCT1000001"
                        }))}
                        rules={[{ required: true, message: ERROR_MSGS.SEL_DEAL_TYPE_ERR_MSG }]}
                    />
                </Col>
                <Col xs={24}>
                    <CustomInput
                        label="Business Description (Max 500 chars and exclude business name)"
                        name="busDesc"
                        rows={4}
                        isTextArea={true}
                        type="text"
                        isRequired={true}
                        disabled={lockNarrative}
                        placeholder="Enter your Business Description"
                        rules={descriptionRules("Business")}
                    />
                </Col>
                <Col xs={24}>
                    <CustomInput
                        label="Financial Summary (Max 500 chars)"
                        name="finSummary"
                        rows={4}
                        isRequired={true}
                        isTextArea={true}
                        type="text"
                        disabled={lockNarrative}
                        placeholder="Enter your Financial Summary"
                        rules={financialSummaryRules}
                    />
                </Col>
            </Row>
        </Spin >
    )
}

export default KycAdditionalInfo